import React from 'react';
import './reportAnswerLikertScale.scss';
import {QuestionReport} from '../../../../analytics';

const colors = ['#183b3c', '#3c6061', '#35465f', '#4b6283', '#8A9BAF', '#CCCED0', '#ddb191', '#c97748', '#c65144', '#c64a86'];

interface ReportAnswerLikertScaleProps {
    questionReport: QuestionReport;
    visibilityLimit?: number;
}

function ReportAnswerLikertScale({questionReport, visibilityLimit = 0.05}: ReportAnswerLikertScaleProps): JSX.Element | null {
    if (!questionReport.likertScaleData) return null;
    const questions = questionReport.likertScaleData.map((question) => question.questionText.toString());
    const scales = questionReport.answers.map((scale) => scale.answerText) || [];
    const scaleLength = questionReport.answers.length;
    const percentages = questionReport.likertScaleData.map((questionData) => {
        const scaleCounts: {[key: number]: number} = {};
        let totalResponses = 0;

        Object.keys(questionData).forEach((key) => {
            const numKey = parseInt(key);
            const value = questionData[key];

            if (!Number.isNaN(numKey) && typeof value === 'number') {
                scaleCounts[numKey] = value;
                totalResponses += value;
            }
        });

        const percentages: number[] = [];
        for (let i = 0; i < scaleLength; i++) {
            const scaleValue = i + 1;
            const count = scaleCounts[scaleValue] || 0;
            const percentage = totalResponses > 0 ? count / totalResponses : 0;
            percentages.push(percentage);
        }

        return percentages;
    });

    return (
        <div className="c-reportAnswerLikertScale">
            {questions.map((question, index) => {
                const questionPercentages = percentages[index];
                return (
                    <div key={index} className="c-reportAnswerLikertScale__question">
                        <div className="c-reportAnswerLikertScale__question">{question}</div>
                        <div className="c-reportAnswerLikertScale__answers">
                            {questionPercentages?.map((percentage, answerIndex) => (
                                <div
                                    style={{
                                        width: `${percentage * 100}%`,
                                        backgroundColor: `${colors[answerIndex % colors.length]}`,
                                    }}
                                    className="c-reportAnswerLikertScale__answers_answer"
                                />
                            ))}
                        </div>
                        <div className="c-reportAnswerLikertScale__percentages">
                            {questionPercentages?.map((percentage) => (
                                <div
                                    style={{
                                        width: `${percentage * 100}%`,
                                        visibility: percentage >= visibilityLimit ? 'visible' : 'hidden',
                                    }}
                                    className="c-reportAnswerLikertScale__percentages_item"
                                >
                                    {Math.round(percentage * 100)}%
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
            <div className="c-reportAnswerLikertScale__legend">
                {scales.map((scale, index) => (
                    <>
                        <div className="c-reportAnswerLikertScale__legend_circle" style={{backgroundColor: colors[index]}} />
                        <div>{scale}</div>
                    </>
                ))}
            </div>
        </div>
    );
}
export default ReportAnswerLikertScale;
